import React from 'react';
import './About.css';

const About = () => {
  const team = [
    { 
      name: "Jack", 
      role: "Chief Executive Officer", 
      job: "Leading the strategic vision and long-term growth of Acurio's dental OS platform.",
      image: "/team1.jpg" // Added image path
    },
    { 
      name: "Sarah Jenkins", 
      role: "Director of Operations", 
      job: "Overseeing daily dental practice workflows and ensuring seamless module integration.",
      image: "/team2.jpg" // Added image path
    },
    { 
      name: "Marcus Chen", 
      role: "Relationship Manager", 
      job: "Building strong partnerships with dental practitioners to ensure long-term success.",
      image: "/team3.jpg" // Added image path
    }
  ];

  return (
    <div className="fade-in">
      {/* --- ORIGINAL TOP SECTION --- */}
      <header className="about-header">
        <div className="header-content">
          <h1>Built for Dental Practice Success.</h1>
          <p>A world-class human team, a robust automated platform: acurio.io.</p>
        </div>
        <div className="bg-letter">A</div>
      </header>

      <section className="about-cards">
        <div className="platform-card teal-top">
          <h3 className="card-icon-teal">The acurio.io Platform</h3>
          <p>Streamline operations with our 7-part RCM platform, including Insurance Verification and Credentialing.</p>
        </div>
        <div className="platform-card purple-top">
          <h3 className="card-icon-purple">IT & Communication</h3>
          <p>Advanced IT solutions: integrated AI Chatbot and SMS reminders specifically for dental workflows.</p>
        </div>
      </section>

      {/* --- NEW RIPPLING-STYLE TEAM SECTION --- */}
      <section className="team-container">
        <div className="team-header-title">
          <h2>Meet our leadership team</h2>
        </div>
        <div className="team-grid">
          {team.map((member, index) => (
            <div key={index} className="team-card">
              {/* Added the actual image tag here */}
              <img src={member.image} alt={member.name} className="team-image" />
              
              <div className="team-card-info">
                <h4>{member.name}</h4>
                <span className="team-role">{member.role}</span>
                <p className="team-desc">{member.job}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default About;